import $ from 'jquery'
import {handleClickProductCatTypeMenuItem, serialize, setSameHeight} from './utils'

export {navigation as default}

const navigation = () => {
  $(() => {
    $(window).scroll(() => {
      if ($(window).scrollTop() > 150) {
        // $('.site-header.float').css('top', 0 + 'px')
        $('.site-header.float').addClass('active')
      } else {
        // $('.site-header.float').css('top', -200 + 'px')
        $('.site-header.float').removeClass('active')
      }
    })
    // footer menu
    let $footerMenu = $('footer.site-footer .menu-footer-container')
    if ($footerMenu.length) {
      $footerMenu.find('li.menu-item-has-children > a').after('<div class="toggle-sub-menu"><span class="icon-chevron-down"></span></div>').click(e => {
        e.preventDefault()
        $(e.target).next().next('.sub-menu').slideToggle('slow')
      })
      $footerMenu.find('li.menu-item-has-children > .toggle-sub-menu').click(e => {
        $(e.target).next('.sub-menu').slideToggle('slow')
      })
    }
    // footer contact us
    let $footerContactUs = $('footer.site-footer .menu-fake')
    if ($footerContactUs.length) {
      $footerContactUs.find('.lvl__1').click(e => {
        $(e.target).next().next('.sub-menu').slideToggle('slow')
      })
      $footerContactUs.find('.toggle-sub-menu').click(e => {
        $(e.target).next('.sub-menu').slideToggle('slow')
      })
    }
    // header menu
    let $headerStatic = $('header.site-header.static')
    if ($headerStatic.length) {
      /**
       * Mobile
       */
      // set same height menu-item lv3
      $headerStatic.find('.nav-bar .main-navigation.mobile').css({   // hack to get sub-menu lv 3 height
        display: 'block',
        visibility: 'hidden'
      })
      $headerStatic.find('.nav-bar .main-navigation.mobile ul.menu > li.menu-item-has-children').each((index, item) => {
        $(item).children('.sub-menu').addClass('active')
        // setSameHeight($(item).children('.sub-menu').children('li').children('a'))
        $(item).children('.sub-menu').removeClass('active')
      })
      $headerStatic.find('.nav-bar .main-navigation.mobile').attr('style', '')
      // toggle main menu
      $headerStatic.find('.menu-trigger > span').click(e => {
        $(e.target).toggleClass('icon-close icon-bars')
        $headerStatic.find('.nav-bar .main-navigation.mobile').slideToggle('slow')

        $('.header-overlay').toggleClass('active')
        $headerStatic.toggleClass('show-overlay')

      })
      // toggle sub menu lvl 2
      $headerStatic.find('.nav-bar .main-navigation > .menu-header-mobile-container > ul.menu > li.menu-item-has-children > a').click(e => {
        e.preventDefault()
        $(e.target).next('.sub-menu').addClass('active')
        $(e.target).parent().parent().css('transform', 'translate(-100%, 0)')
        $headerStatic.find('.menu-trigger > span').addClass('inactive')
        $headerStatic.find('.menu-trigger > .back').addClass('active')
      })
      // back from sub menu lvl 2 to menu lvl 1
      $headerStatic.find('.menu-trigger .back').click(e => {
        e.preventDefault()
        $headerStatic.find('.nav-bar .main-navigation > .menu-header-mobile-container > ul.menu').css('transform', 'translate(0, 0)')
        $headerStatic.find('.nav-bar .main-navigation > .menu-header-mobile-container > ul.menu li.menu-item-has-children > .sub-menu').removeClass('active')
        $headerStatic.find('.menu-trigger > span').removeClass('inactive')
        $headerStatic.find('.menu-trigger > .back').removeClass('active')
      })
      // toggle sub menu lvl 3
      $headerStatic.find('.nav-bar .main-navigation > .menu-header-mobile-container > ul.menu > li.menu-item-has-children > .sub-menu > li.menu-item-has-children > a').click(e => {
        e.preventDefault()
        if ($(e.target).next('.sub-menu').hasClass('active')) {
          $(e.target).next('.sub-menu').removeClass('active')
        } else {
          $(e.target).parent().parent().children('li.menu-item-has-children').children('.sub-menu').removeClass('active')
          $(e.target).next('.sub-menu').addClass('active')
        }
      })
      // menu filter product cat
      $headerStatic.find('.nav-bar .main-navigation.mobile .menu-item.menu-item-has-product-cat-order').click(e => {
        e.preventDefault()
        handleClickProductCatTypeMenuItem(e)
      })
      // set same height .cat-item > span
      $headerStatic.find('.nav-bar .menu-filter').css({
        display: 'block',
        visibility: 'hidden'
      })
      $headerStatic.find('.nav-bar .menu-filter .menu-filter-item').each((index, item) => {
        $(item).css({
          display: 'block',
          visibility: 'hidden'
        })
        setSameHeight($(item).children('.cat-list').children('.cat-item').children('span'))
        $(item).css({
          display: '',
          visibility: ''
        })
      })
      $headerStatic.find('.nav-bar .menu-filter').css({
        display: '',
        visibility: ''
      })
      $headerStatic.find('.nav-bar .menu-filter .close').click(e => {
        e.preventDefault()
        $('.header-overlay').removeClass('active')
        $('header.site-header .menu-trigger').css('opacity', 1)
        $(e.target).closest('.menu-filter').find('.menu-filter-item.active').removeClass('active')
        $(e.target).closest('.menu-filter').hide()
      })
      $headerStatic.find('.nav-bar .menu-filter .back').click(e => {
        e.preventDefault()
        const $target = $(e.target)
        $target.closest('.menu-filter').children('.close').addClass('active')
        $target.closest('.menu-filter').children('.back').removeClass('active')
        $target.closest('.menu-filter').find('.menu-filter-item.active > .cat-list').css('transform', '')
        $target.closest('.menu-filter').find('.menu-filter-item.active > .cat-list .sub-cat.active').removeClass('active')
      })
      $headerStatic.find('.nav-bar .menu-filter .menu-filter-item > .cat-list > .cat-item > span').click(e => {
        e.preventDefault()
        const $target = $(e.target)

        if ($target.data('href')) {
          window.location.href = $target.data('href')
          return
        }

        $target.next('.sub-cat').addClass('active')
        $target.closest('.cat-list').css('transform', 'translate(-100%, 0)')
        $target.closest('.menu-filter').children('.close').removeClass('active')
        $target.closest('.menu-filter').children('.back').addClass('active')
      })
      $headerStatic.find('.nav-bar .menu-filter .menu-filter-item > .cat-list > .cat-item .sub-cat .cat-list.cat .cat-item').click(e => {
        e.preventDefault()
        const $catItem = $(e.target).closest('.cat-item')

        if ($catItem.data('href')) {
          window.location.href = $catItem.data('href')
          return
        }

        if (!$catItem.hasClass('active'))
          $(e.target).closest('.cat-list.cat').children('.cat-item').removeClass('active')
        $catItem.toggleClass('active')
      })
      $headerStatic.find('.nav-bar .menu-filter .menu-filter-item > .cat-list > .cat-item .sub-cat .cat-list.brand .cat-item').click(e => {
        e.preventDefault()
        $(e.target).closest('.cat-item').toggleClass('active')
      })
      $headerStatic.find('.nav-bar .menu-filter .menu-filter-item .submit > .clear').click(e => {
        e.preventDefault()
        $(e.target).closest('.sub-cat').find('.cat-item.active').removeClass('active')
      })
      $headerStatic.find('.nav-bar .menu-filter .menu-filter-item .submit > .apply').click(e => {
        e.preventDefault()
        const $target = $(e.target)
        const $menuFilterItem = $target.closest('.menu-filter-item')
        const url = $menuFilterItem.data('href')
        const activeCats = $menuFilterItem.find('.cat-list.cat > .cat-item.active').toArray().map(item => {
          return item.getAttribute('slug')
        })
        const activeBrands = $menuFilterItem.find('.cat-list.brand > .cat-item.active').toArray().map(item => {
          return item.getAttribute('slug')
        })
        const q = serialize({
          product_cat: activeCats,
          product_brand: activeBrands
        })
        window.location.href = url + '?' + q
      })

      /**
       * Desktop
       */
      // overlay when hovering
      $headerStatic.find('.nav-bar .main-navigation.desktop > .menu-header-desktop-container > ul.menu > li.menu-item-has-children').hover(() => {
        $('.header-overlay').toggleClass('active')
        $headerStatic.addClass('show-overlay')
      }, () => {
        $('.header-overlay').toggleClass('active')
        $headerStatic.removeClass('show-overlay')
      })

      // $headerStatic.find('.nav-bar .main-navigation.desktop > .menu-header-desktop-container > ul.menu > li.menu-item-has-children:not(:first-child) > .sub-menu > li.menu-item-has-children').hover(e => {
      //   let li = $(e.target).closest('li.menu-item-has-children')
      //   li.siblings().addClass('not-hover')
      // }, e => {
      //   let li = $(e.target).closest('li.menu-item-has-children')
      //   li.siblings().removeClass('not-hover')
      // })

      // calculate top position sub menu lvl 3
      let $menu = $headerStatic.find('.nav-bar .main-navigation > .menu-header-desktop-container > ul.menu')
      let $subMenuLv2 = $headerStatic.find('.nav-bar .main-navigation > .menu-header-desktop-container > ul.menu > li:first-child > .sub-menu')
      let $subMenuLv2Width = $subMenuLv2.width()
      $subMenuLv2.css({   // hack to get sub-menu lv 3 height
        display: 'block',
        visibility: 'hidden'
      })
      // // top position
      // let subMenuLv2TopPosition = $subMenuLv2.offset().top
      // // bot position is calculated by finding all children in sub-menu lv 2 and multiply it by 46 (<li> height)
      // let subMenuLv2BotPosition = subMenuLv2TopPosition + $subMenuLv2.children('li').length * 46
      // // top <li> position is equal to top position at the beginning
      // let liChildTopPosition = subMenuLv2TopPosition
      // // bot <li> position is calculated by add <li> top position to 46 (<li> height)
      // let liChildBotPosition = liChildTopPosition + 46
      $subMenuLv2.children('li').each((index, item) => {
        // run when li has children
        if ($(item).hasClass('menu-item-has-children')) {
          let $subMenuLv3 = $(item).children('.sub-menu')
          $subMenuLv3.css({
            'left': `${$subMenuLv2Width}px`,
            'width': $menu.width() - $subMenuLv2Width + 'px',    // maxWidth of .container class minus sub-menu lv 2 width
            'height': $subMenuLv2.height(),    // sub menu lv2 (left sidebar) height
          })
          // let subMenuLv3Height = $subMenuLv3.outerHeight()
          // // if position after translating 50% is greater than bottom, then set subMenuLv3 to bottom of subMenuLv2
          // if (liChildBotPosition + subMenuLv3Height / 2 > subMenuLv2BotPosition) {
          //   $subMenuLv3.css('bottom', 0)    // bottom of subMenuLv2
          // }
          // // if position after translating 50% is smaller than top, then set subMenuLv3 to top of subMenuLv2
          // else if (liChildTopPosition - subMenuLv3Height / 2 < subMenuLv2TopPosition) {
          //   $subMenuLv3.css('top', 0)    // top of subMenuLv2
          // }
          // // if not 2 above condition, subMenuLv3's height is not over the edges, then translating 54%
          // else {
          //   $subMenuLv3.css('transform', 'translate(0, -50%)')
          // }
          $subMenuLv3.children('li.group_1').appendTo($('<div>', {
            class: 'w-25 group'
          }).appendTo($subMenuLv3))
          $subMenuLv3.children('li.group_2').appendTo($('<div>', {
            class: 'w-25 group'
          }).appendTo($subMenuLv3))
          $subMenuLv3.children('li.group_3').appendTo($('<div>', {
            class: 'w-25 group'
          }).appendTo($subMenuLv3))
          $subMenuLv3.children('li.group_4').appendTo($('<div>', {
            class: 'w-25 group'
          }).appendTo($subMenuLv3))
        }
        // // increase <li> position values after each round
        // liChildTopPosition += 46
        // liChildBotPosition += 46
      })
      let $subMenuLv2NotChildOfFirstLi = $headerStatic.find('.nav-bar .main-navigation > .menu-header-desktop-container > ul.menu > li:not(:first-child) > .sub-menu')
      $subMenuLv2NotChildOfFirstLi.each((index, item) => {
        $(item).css({
          'left': $subMenuLv2Width,
          'width': `calc(100% - ${$subMenuLv2Width}px)`,
          'height': $subMenuLv2.height(),
        })
      })
      $subMenuLv2.attr('style', '')   // remove hack style rules

      // let old$subMenuLv2Width = $subMenuLv2Width
      // $subMenuLv2 = $headerStatic.find('.nav-bar .main-navigation > .menu-header-desktop-container > ul.menu > li:not(:first-child) > .sub-menu')
      // $subMenuLv2Width = $subMenuLv2.outerWidth()
      // console.log('$subMenuLv2Width', $subMenuLv2Width)
      // $subMenuLv2.children('li').each((index, item) => {
      //   if ($(item).hasClass('menu-item-has-children'))
      //     $(item).find('.sub-menu').css({
      //       'left': $subMenuLv2Width + 'px',
      //       'max-width': $menu.width() - $subMenuLv2Width - old$subMenuLv2Width + 'px'
      //     })
      // })

      // menu day, cap dien => change layout
      let $menuElectricItems = $headerStatic.find('.nav-bar .main-navigation > .menu-header-desktop-container > ul.menu > li:first-child > .sub-menu > li:first-child > .sub-menu')
      for (const item of $menuElectricItems.children('.menu-item-has-children')) {
        const $children = $(item).nextUntil('.menu-item-has-children')
        $(item).append($('<ul/>', {
          class: 'sub-menu'
        }).append($children))
      }
    }
    let $headerFloat = $('.site-header.float')
    if ($headerFloat.length) {
      /**
       * Mobile
       */
      // set same height menu-item lv3
      $headerFloat.find('.nav-bar .main-navigation.mobile').css({   // hack to get sub-menu lv 3 height
        display: 'block',
        visibility: 'hidden'
      })
      $headerFloat.find('.nav-bar .main-navigation.mobile ul.menu > li.menu-item-has-children').each((index, item) => {
        $(item).children('.sub-menu').addClass('active')
        // setSameHeight($(item).children('.sub-menu').children('li').children('a'))
        $(item).children('.sub-menu').removeClass('active')
      })
      $headerFloat.find('.nav-bar .main-navigation.mobile').attr('style', '')
      // toggle main menu
      $headerFloat.find('.menu-trigger > span').click(e => {
        $(e.target).toggleClass('icon-close icon-bars')
        $headerFloat.find('.nav-bar .main-navigation.mobile').slideToggle('slow')

        $('.header-overlay').toggleClass('active')
        $headerStatic.toggleClass('show-overlay')
      })
      // toggle sub menu lvl 2
      $headerFloat.find('.nav-bar .main-navigation > .menu-header-mobile-container > ul.menu > li.menu-item-has-children > a').click(e => {
        e.preventDefault()
        $(e.target).next('.sub-menu').addClass('active')
        $(e.target).parent().parent().css('transform', 'translate(-100%, 0)')
        $headerFloat.find('.menu-trigger > span').addClass('inactive')
        $headerFloat.find('.menu-trigger > .back').addClass('active')
      })
      // back from sub menu lvl 2 to menu lvl 1
      $headerFloat.find('.menu-trigger .back').click(e => {
        e.preventDefault()
        $headerFloat.find('.nav-bar .main-navigation > .menu-header-mobile-container > ul.menu').css('transform', 'translate(0, 0)')
        $headerFloat.find('.nav-bar .main-navigation > .menu-header-mobile-container > ul.menu li.menu-item-has-children > .sub-menu').removeClass('active')
        $headerFloat.find('.menu-trigger > span').removeClass('inactive')
        $headerFloat.find('.menu-trigger > .back').removeClass('active')
      })
      // toggle sub menu lvl 3
      $headerFloat.find('.nav-bar .main-navigation > .menu-header-mobile-container > ul.menu > li.menu-item-has-children > .sub-menu > li.menu-item-has-children > a').click(e => {
        e.preventDefault()
        if ($(e.target).next('.sub-menu').hasClass('active')) {
          $(e.target).next('.sub-menu').removeClass('active')
        } else {
          $(e.target).parent().parent().children('li.menu-item-has-children').children('.sub-menu').removeClass('active')
          $(e.target).next('.sub-menu').addClass('active')
        }
      })
      // menu filter product cat
      $headerFloat.find('.nav-bar .main-navigation.mobile .menu-item.menu-item-has-product-cat-order').click(e => {
        e.preventDefault()
        $('html, body').animate({
          scrollTop: 0
        }, 'fast')
        handleClickProductCatTypeMenuItem(e)
      })

      /**
       * Desktop
       */
      // overlay when hovering
      $headerFloat.find('.nav-bar .main-navigation.desktop > .menu-header-desktop-container > ul.menu > li.menu-item-has-children').hover(() => {
        $('.header-overlay').toggleClass('active')
        $headerStatic.addClass('show-overlay')
      }, () => {
        $('.header-overlay').toggleClass('active')
        $headerStatic.removeClass('show-overlay')
      })
      // calculate top position sub menu lvl 3
      let $menu = $headerFloat.find('.nav-bar .main-navigation > .menu-header-desktop-container > ul.menu')
      let $subMenuLv2 = $headerFloat.find('.nav-bar .main-navigation > .menu-header-desktop-container > ul.menu > li:first-child > .sub-menu')
      let $subMenuLv2Width = $subMenuLv2.width()
      $subMenuLv2.style('display', 'block', 'important')
      $subMenuLv2.css({   // hack to get sub-menu lv 3 height
        // display: 'block !important',
        visibility: 'hidden'
      })
      // // top position
      // let subMenuLv2TopPosition = $subMenuLv2.offset().top
      // // bot position is calculated by finding all children in sub-menu lv 2 and multiply it by 54 (<li> height)
      // let subMenuLv2BotPosition = subMenuLv2TopPosition + $subMenuLv2.children('li').length * 54
      // // top <li> position is equal to top position at the beginning
      // let liChildTopPosition = subMenuLv2TopPosition
      // // bot <li> position is calculated by add <li> top position to 54 (<li> height)
      // let liChildBotPosition = liChildTopPosition + 54
      $subMenuLv2.children('li').each((index, item) => {
        // run when li has children
        if ($(item).hasClass('menu-item-has-children')) {
          let $subMenuLv3 = $(item).children('.sub-menu')
          $subMenuLv3.css({
            'left': `${$subMenuLv2Width}px`,
            'width': $menu.width() - $subMenuLv2Width + 'px',    // maxWidth of .container class minus sub-menu lv 2 width
            'height': $subMenuLv2.height(),    // sub menu lv2 (left sidebar) height
          })
          // let subMenuLv3Height = $subMenuLv3.outerHeight()
          // // if position after translating 50% is greater than bottom, then set subMenuLv3 to bottom of subMenuLv2
          // if (liChildBotPosition + subMenuLv3Height / 2 > subMenuLv2BotPosition) {
          //   $subMenuLv3.css('bottom', 0)    // bottom of subMenuLv2
          // }
          // // if position after translating 50% is smaller than top, then set subMenuLv3 to top of subMenuLv2
          // else if (liChildTopPosition - subMenuLv3Height / 2 < subMenuLv2TopPosition) {
          //   $subMenuLv3.css('top', 0)    // top of subMenuLv2
          // }
          // // if not 2 above condition, subMenuLv3's height is not over the edges, then translating 54%
          // else {
          //   $subMenuLv3.css('transform', 'translate(0, -50%)')
          // }
          $subMenuLv3.children('li.group_1').appendTo($('<div>', {
            class: 'w-25 group'
          }).appendTo($subMenuLv3))
          $subMenuLv3.children('li.group_2').appendTo($('<div>', {
            class: 'w-25 group'
          }).appendTo($subMenuLv3))
          $subMenuLv3.children('li.group_3').appendTo($('<div>', {
            class: 'w-25 group'
          }).appendTo($subMenuLv3))
          $subMenuLv3.children('li.group_4').appendTo($('<div>', {
            class: 'w-25 group'
          }).appendTo($subMenuLv3))
        }
        // // increase <li> position values after each round
        // liChildTopPosition += 54
        // liChildBotPosition += 54
      })
      let $subMenuLv2NotChildOfFirstLi = $headerFloat.find('.nav-bar .main-navigation > .menu-header-desktop-container > ul.menu > li:not(:first-child) > .sub-menu')
      $subMenuLv2NotChildOfFirstLi.each((index, item) => {
        $(item).css({
          'left': $subMenuLv2Width,
          'width': `calc(100% - ${$subMenuLv2Width}px)`,
          'height': $subMenuLv2.height(),
        })
      })
      $subMenuLv2.attr('style', '')   // remove hack style rules

      // let old$subMenuLv2Width = $subMenuLv2Width
      // $subMenuLv2 = $headerFloat.find('.nav-bar .main-navigation > .menu-header-desktop-container > ul.menu > li:not(:first-child) > .sub-menu')
      // $subMenuLv2Width = $subMenuLv2.outerWidth()
      // // console.log('$subMenuLv2Width', $subMenuLv2Width)
      // $subMenuLv2.children('li').each((index, item) => {
      //   if ($(item).hasClass('menu-item-has-children'))
      //     $(item).find('.sub-menu').css({
      //       'left': $subMenuLv2Width + 'px',
      //       'max-width': $menu.width() - $subMenuLv2Width - old$subMenuLv2Width + 'px'
      //     })
      // })

      // menu day, cap dien => change layout
      let $menuElectricItems = $headerFloat.find('.nav-bar .main-navigation > .menu-header-desktop-container > ul.menu > li:first-child > .sub-menu > li:first-child > .sub-menu')
      for (const item of $menuElectricItems.children('.menu-item-has-children')) {
        const $children = $(item).nextUntil('.menu-item-has-children')
        $(item).append($('<ul/>', {
          class: 'sub-menu'
        }).append($children))
      }
    }
  })
}
